import { ISearchConfigurationsResult } from './types'
import { useAllResultsOrder, useSupportedSearchConfigs } from './use-supported-search-configs'

/**
 * Note: the order of these search configurations is the order in which they will appear in the tabs list
 * @returns {types.ISearchConfiguration[]}
 */
export const useSearchConfigurations = (): ISearchConfigurationsResult => {
  const { searchConfigurations, supportedSearchTypes } = useSupportedSearchConfigs()
  const allResultsOrder = useAllResultsOrder(supportedSearchTypes)

  return { searchConfigurations, allResultsOrder }
}
